import '../App.css';
import lastPaintings from '../data/last_paintings.json';
import PaintingCard from '../components/PaintingCard';


function Accueil() {

    return (
        <>
            <section className="text-center py-20">
                <div className="max-w-4xl mx-auto px-4">
                    
                    <h1 className='text-center font-bold text-5xl md:text-6xl text-gray-900'>
                        Ma mère, une
                        <span className='ml-3 dancing-script text-6xl md:text-7xl accent-orange relative'>artiste</span>
                    </h1>

                    <p className="mt-8 text-gray-700 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
                        Passionnée de peinture depuis toujours, elle transforme ses inspirations et émotions en toiles uniques. 
                        Chaque coup de pinceau raconte une histoire. <span className="accent-orange font-medium">Découvrez son univers.</span>
                    </p>
                    
                    <div className="mt-10">
                        <a href="#dernieres-realisations" className="btn-artist inline-block rounded-full relative z-10">
                            Voir les dernières créations
                        </a>
                    </div>
                </div>
            </section>
            
            <section className='mt-16 pb-16' id="dernieres-realisations">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="text-center mb-12">
                        <h2 className='text-4xl font-bold text-gray-900 inline-block relative'>
                            Dernières réalisations
                            <span className="absolute -bottom-2 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-orange-500 to-transparent"></span>
                        </h2>
                        <p className="mt-4 text-gray-600">Mes créations les plus récentes</p>
                    </div>
                    
                    <ul className="grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                        {
                            lastPaintings.map((painting, index) => (
                                <li key={index}>
                                    <PaintingCard infos={painting} index={index} />
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </section>
        </>
    );
}

export default Accueil;
